import { render, staticRenderFns } from "./account-menu-user-info.vue?vue&type=template&id=5d6ca41a&scoped=true"
import script from "./account-menu-user-info.vue?vue&type=script&lang=js"
export * from "./account-menu-user-info.vue?vue&type=script&lang=js"
import style0 from "./account-menu-user-info.vue?vue&type=style&index=0&id=5d6ca41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ca41a",
  null
  
)

/* custom blocks */
import block0 from "./account-menu-user-info.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports